export const DEBUG_LANGUAGE_STORAGE_KEY = "debugLanguage";
export const isDebugLanguageEnabled = () => {
  return window.sessionStorage.getItem(DEBUG_LANGUAGE_STORAGE_KEY) === "true";
};

const val = new URLSearchParams(window.location.search).get("debugLanguage");
if (val) {
  window.sessionStorage.setItem(DEBUG_LANGUAGE_STORAGE_KEY, val.toLowerCase() === "true" ? "true" : "false");
}
